<template>
	<div class="w-100 float-left">
		<swiper class="home-slider" :options="swiperOption">
			<swiper-slide v-for="(slider, index) in sliders"
						  :key="index"
						  class="item"
						  v-if="screenWidth > 900 && (slider.sliderDeviceTypeID == 1 || slider.sliderDeviceTypeID == 2)">
				<div v-if="!slider.urlPath"
					 class="bg-home-slider"
					 v-bind:style="{
						'background-image':
							'url(' + rootImagePath + slider.imagePath + ')'
					}"></div>
				<a :href="slider.urlPath"
				   v-if="slider.urlPath"
				   class="bg-home-slider"
				   v-bind:style="{
						'background-image':
							'url(' + rootImagePath + slider.imagePath + ')'
					}"></a>
				<p>{{ slider.description }}</p>
			</swiper-slide>
			<swiper-slide v-for="(slider, index) in sliders"
						  :key="index"
						  class="item"
						  v-if="screenWidth <= 900 && (slider.sliderDeviceTypeID == 1 || slider.sliderDeviceTypeID == 3)" >
				<div
					v-if="!slider.urlPath"
					class="bg-home-slider"
					v-bind:style="{'background-image':'url(' + rootImagePath + slider.imagePath + ')'}"
				></div>
				<a
					:href="slider.urlPath"
					v-if="slider.urlPath"
					class="bg-home-slider"
					v-bind:style="{'background-image':'url(' + rootImagePath + slider.imagePath + ')' }"
				></a>
				<p>{{ slider.description }}</p>
			</swiper-slide>
			<div class="swiper-button-prev" slot="button-prev"></div>
			<div class="swiper-button-next" slot="button-next"></div>
		</swiper>
	</div>
</template>
<script>
	export default {
		props: {
			rootImagePath: {
				type: String
			},

			sliders: {
				type: Array
			}
		},

		data()
		{
			return {
				screenWidth: 0,
				swiperOption: {
					loop: true,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					}
				}
			};
		},

		beforeMount()
		{
			this.screenWidth = window.outerWidth;
		},

		methods: {
			updateScroll()
			{
				this.screenWidth = window.outerWidth;
				this.scrollPosition = window.scrollY;
			}
		}
	};
</script>
<style scoped>
	.home-slider,
	.home-slider .item,
	.home-slider .bg-home-slider {
		width: 100%;
		float: left;
		height: 600px;
	}

	.home-slider {
		padding: 0 !important;
		margin-top: 50px;
	}

		.home-slider .bg-home-slider {
			background-position: top center;
			background-size: contain;
			background-repeat: no-repeat;
		}

		.home-slider p {
			text-align: center;
			width: 100%;
		}

	@media (max-width: 1024px) {
		.home-slider,
		.home-slider .item,
		.home-slider .bg-home-slider {
			height: 400px;
		}

		.swiper-button-prev,
		.swiper-button-next {
			display: none;
		}
	}
</style>
